<declarative-form
  #declarativeForm
  [pages]="this.pages"
  [page]="this.page"
  [validationStrategy]="validationStrategy"
  (isValidChanged)="this.isValidChanged.emit($event)"
></declarative-form>
